<template>
  <div class="text-center mb-8">
    <h1>Hangman</h1>
    <p>Find the hidden word - Enter a letter</p>
  </div>
</template>
